import { useEffect, useState } from 'react';

import { getScrollObserverRootElement } from '../utils/scrollObserver';
import useScrollObserverRootContext from './useScrollObserverRootContext';

export default function useScrollObserverRootHeight(): undefined | number {
  const { rootId } = useScrollObserverRootContext();
  const [rootHeight, setRootHeight] = useState<number>();

  useEffect(() => {
    const rootElement = getScrollObserverRootElement(rootId);
    if (!rootElement) return;

    const observer = new ResizeObserver(([entry]) => {
      setRootHeight(entry.contentRect.height);
    });
    observer.observe(rootElement);

    return () => observer.disconnect();
  }, [rootId]);

  return rootHeight;
}
